import { handleOnchangeFilter, handleSaApplyFilter, handleSaJobGet } from 'Actions/SuperAdmin/JobsAction';
import { store } from 'indexStore';
import React from 'react'
import Select from 'react-dropdown-select'
import Autocomplete from "react-google-autocomplete";
import { IoClose } from 'react-icons/io5';
import { updateFilterLocationSearch } from 'Slices/SuperAdmin/Jobs';

const SaJobFilterWigdet = ({
  seleced_filter_data, filter_parameters,
  dispatch, jobId
}) => {
  const state = store.getState()

  return (
    <div className="container">
      <div className="row g-2 p-3 pb-5">
        <div className="col-12">
          <div className="mb-4">
            <h6 className="fw-bold">Skills</h6>
            <Select
              multi
              color="#ffa32d"
              style={{ fontSize: ".9rem" }}
              className="rounded-1"
              options={!seleced_filter_data?.skill || seleced_filter_data?.skill?.length < 5 ? filter_parameters?.skill : []}
              addPlaceholder="Select up to 5 Skills"
              onChange={(values) => dispatch(handleOnchangeFilter({ field: "skills", value: values, data: filter_parameters?.skill }))}
              values={seleced_filter_data?.skill}
            />
          </div>
        </div>

        <div className="col-12">
          <div className="">
            <div className='mb-0'>
              <h6 className='fw-bold'>Location</h6>
              <div className={seleced_filter_data?.location?.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                {seleced_filter_data?.location?.map((v) => (
                  <div className="col-12 py-1 pe-1">
                    <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                      <div className="col-11">
                        <p className='w-100 mb-0 text-break'>{v}</p>
                      </div>
                      <div className="col-1">
                        <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleOnchangeFilter({ field: "location_delete", deletion_value: v, data: state?.saJobsState?.seleced_filter_data?.location }))} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Autocomplete
                apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                className='google-places-api'
                onPlaceSelected={(place) => {
                  if (place) {
                    dispatch(handleOnchangeFilter({ field: "location_push", place: place.address_components, data: state }))
                  }
                }}
                onChange={(e) => dispatch(updateFilterLocationSearch(e.target.value))}
                value={state?.saJobsState?.filter_location_search || ''}
                disabled={seleced_filter_data?.location?.length === 5}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="w-100">
        <button type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn w-100" onClick={() => dispatch(handleSaApplyFilter(state?.saJobsState))}>Apply Filter</button>
        <button type="button" className="btn btn-transparent border border-brand-color w-100 my-2" onClick={() => dispatch(handleSaJobGet({ job_id: jobId, status: "All" }))}>Clear Filter</button>
      </div>
    </div>
  )
}

export default SaJobFilterWigdet